var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a7b1b080eaee5fb45e104245eec8d5c9970e9697"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-toolkit@frontend-toolkit"]={id:"a7b1b080eaee5fb45e104245eec8d5c9970e9697"};
      